var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStatusDisplayErrorIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#B00002"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.67674 2.81818L8.5773 10.1364H7.42389L7.32446 2.81818H8.67674ZM8.0006 13.0795C7.75533 13.0795 7.54487 12.9917 7.36921 12.816C7.19354 12.6404 7.10571 12.4299 7.10571 12.1847C7.10571 11.9394 7.19354 11.7289 7.36921 11.5533C7.54487 11.3776 7.75533 11.2898 8.0006 11.2898C8.24586 11.2898 8.45633 11.3776 8.63199 11.5533C8.80765 11.7289 8.89549 11.9394 8.89549 12.1847C8.89549 12.3471 8.85406 12.4962 8.7712 12.6321C8.69165 12.768 8.58393 12.8774 8.44804 12.9602C8.31547 13.0398 8.16632 13.0795 8.0006 13.0795Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusDisplayErrorIcon);
export default __webpack_public_path__ + "static/media/status-display-error-icon.83ac9e13b0da1e6c987cfcc2fb5ae5cf.svg";
export { ForwardRef as ReactComponent };